import Logger, { createLoggerFor, dbServiceLogger } from './logger';

export default Logger;
export { createLoggerFor, dbServiceLogger };
